<template>
    <div class="graduationProve">
        <div class="graduationProve-box">
            <Title text="毕业证明书" />
            <div class="top-btn">
                <el-button type="primary" @click="goToPage">毕业证明书申请记录</el-button>
            </div>
            <el-form 
                ref="info" 
                :model="infoData" 
                :rules="infoRules"
                class="demo-ruleForm modify-ruleForm">
                <el-row :gutter="60">
                        <el-col :span="8">
                            <el-form-item label="学生姓名" prop="student_title">
                                <el-input v-model="infoData.student_title" placeholder="请输入学生姓名" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="身份证" prop="identity">
                                <el-input v-model="infoData.identity" placeholder="请输入身份证" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="学号" prop="student_code">
                                <el-input v-model="infoData.student_code" placeholder="请输入学号" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="考生号" prop="candidate_number">
                                <el-input v-model="infoData.candidate_number" placeholder="请输入考生号" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="函授站" prop="school_data">
                                <el-select
                                    v-model="infoData.school_data"
                                    placeholder="请选择函授站"
                                    clearable
                                    filterable
                                    style="width: 100%;"
                                    @change="schoolChange"
                                >
                                    <el-option
                                        v-for="item in schoolList"
                                        :key="item.id"
                                        :label="item.title"
                                        :value="item.id + '-' + item.title"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="班级" prop="class_title">
                                <el-input v-model="infoData.class_title" placeholder="请输入班级" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="学制层次" prop="level_data">
                                <el-select
                                    v-model="infoData.level_data"
                                    placeholder="请选择学制层次"
                                    clearable
                                    filterable
                                    style="width: 100%;"
                                    @change="levelChange"
                                >
                                    <el-option
                                        v-for="item in levelList"
                                        :key="item.id"
                                        :label="item.title"
                                        :value="item.id + '-' + item.title"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="专业" prop="profession_data">
                                <el-select
                                    v-model="infoData.profession_data"
                                    placeholder="请选择专业"
                                    clearable
                                    filterable
                                    style="width: 100%;"
                                    @change="professionChange"
                                >
                                    <el-option
                                        v-for="item in professionList"
                                        :key="item.id"
                                        :label="item.title"
                                        :value="item.id + '-' + item.title"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="联系电话" prop="tel">
                                <el-input v-model="infoData.tel" placeholder="请输入联系电话" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="原毕业证书编号" prop="old_cert_code">
                                <el-input v-model="infoData.old_cert_code" placeholder="请输入原毕业证书编号" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="入学时间" prop="entrance_date">
                                <el-date-picker
                                v-model="infoData.entrance_date"
                                type="month"
                                format="yyyy-MM"
                                value-format="yyyy-MM"
                                placeholder="请选择入学时间"
                                style="width: 100%;">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="毕业时间" prop="grad_date">
                                <el-date-picker
                                v-model="infoData.grad_date"
                                type="month"
                                format="yyyy-MM"
                                value-format="yyyy-MM"
                                placeholder="请选择毕业时间"
                                style="width: 100%;">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="学习形式" prop="shape_title">
                                <el-select
                                    v-model="infoData.shape_title"
                                    placeholder="请选择学习形式"
                                    clearable
                                    filterable
                                    style="width: 100%;"
                                >
                                    <el-option
                                        v-for="item in shapeList"
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="身份证正面照(人像面)" prop="card_img_just_data">
                                <uploadFile
                                    ref="uploadCardImgJust"
                                    @handleChange="upLoadImg($event, 'card_img_just')"
                                    @handleRemove="handleRemove($event, 'card_img_just')"
                                    :fileLists="infoData.card_img_just_data"
                                    :isShowModal="false"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="身份证反面照(国徽面)" prop="card_img_back_data">
                                <uploadFile
                                    ref="uploadCardImgBack"
                                    @handleChange="upLoadImg($event, 'card_img_back')"
                                    @handleRemove="handleRemove($event, 'card_img_back')"
                                    :fileLists="infoData.card_img_back_data"
                                    :isShowModal="false"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="学籍档案照片" prop="archives_img_data">
                                <uploadFile
                                    ref="uploadArchivesImg"
                                    @handleChange="upLoadImg($event, 'archives_img')"
                                    @handleRemove="handleRemove($event, 'archives_img')"
                                    :fileLists="infoData.archives_img_data"
                                    :isShowModal="false"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="证件照" prop="inch_img_data">
                                <uploadFile
                                    ref="uploadInchImg"
                                    @handleChange="upLoadImg($event, 'inch_img')"
                                    @handleRemove="handleRemove($event, 'inch_img')"
                                    :fileLists="infoData.inch_img_data"
                                    :isShowModal="false"
                                />
                                <p style="color: red;">请上传蓝底证件照的电子档，大小20-40k，尺寸480*640.</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="申请书照片" prop="apply_img_data">
                                <uploadFile
                                    ref="uploadApplyImg"
                                    @handleChange="upLoadImg($event, 'apply_img')"
                                    @handleRemove="handleRemove($event, 'apply_img')"
                                    :fileLists="infoData.apply_img_data"
                                    :isShowModal="false"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="申请原因" prop="apply_remark">
                                <el-input
                                    type="textarea"
                                    :rows="3"
                                    placeholder="请输入申请原因"
                                    v-model="infoData.apply_remark"
                                    maxlength="200" show-word-limit />
                            </el-form-item>
                        </el-col>
                </el-row>
            </el-form>
            <div class="btn-box">
                <el-button type="primary" @click="submitInfo">提交</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import {putObject} from '@/utils/upload';
// import {isAssetTypeAnImage} from '@/utils/func';
import {studentPaSchool, studentPaPro} from '@/api/common';
import {studentPaGetPost} from '@/api/graduationProve';
import uploadFile from '@/components/uploadFile';
export default {
    name: 'graduationProve',
    components: { uploadFile },
    filters: {
        // 审核状态
        isCheckFilter(v){
            let obj = {
                0: '待审核',
                1: '已通过', 
                2: '未通过', 
            };
            return obj[v];
        },
        // 审核状态 样式
        isCheckStyle(v){
            let obj = {
                0: '', 
                1: 'success', 
                2: 'danger', 
            };
            return obj[v];
        },
    },
    data(){
        return {
            tableData: [], 

            // 学制层次
            levelList: [
                {id: 1, title: '专升本'},
                {id: 2, title: '高起本'},
                {id: 3, title: '高起专'},
            ],
            schoolList: [],  //函授站列表
            professionList: [],  //专业列表

            // 学习形式
            shapeList: ['函授', '脱产', '业余'],

            //申请修改 
            isShowModifyInfo: false,  
            infoData: {
                student_title: '',  //学生姓名
                identity: '',  //身份证
                student_code: '',  //学号
                candidate_number: '',  //考生号
                school_data: '',
                school_id: '',  //函授站
                school_title: '',  //函授站
                class_title: '',  //班级
                level_data: '', 
                level: '',  //学制层次
                level_title: '',
                profession_data: '',
                profession_id: '',  //专业
                profession_title: '',  //专业
                tel: '',  //联系电话
                old_cert_code: '',  //原毕业证书编号
                entrance_date: '',  //入学时间
                grad_date: '',  //毕业时间
                shape_title: '',  //学习形式

                apply_remark: '',  //申请原因
                card_img_just: '',  //身份证正面照(人像面)
                card_img_just_data: [],
                card_img_back: '',  //身份证反面照(国徽面)
                card_img_back_data: [],  
                archives_img: '',  //学籍档案照片
                archives_img_data: [],
                inch_img: '',  //证件照（寸照）
                inch_img_data: [],

                apply_img: '',  //申请书照片
                apply_img_data: [],
            },
            infoRules: {
                student_title: [{ required: true, message: "请输入学生姓名", trigger: "blur" }],
                identity: [{ required: true, message: "请输入身份证", trigger: "blur" }],
                student_code: [{ required: true, message: "请输入学号", trigger: "blur" }],
                // candidate_number: [{ required: true, message: "请输入考生号", trigger: "blur" }],
                // class_title: [{ required: true, message: "请输入班级", trigger: "blur" }],
                school_data: [{ required: true, message: "请选择函授站", trigger: "change" }],
                level_data: [{ required: true, message: "请选择学制层次", trigger: "change" }],
                profession_data: [{ required: true, message: "请选择专业", trigger: "change" }],
                tel: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
                old_cert_code: [{ required: true, message: "请输入原毕业证书编号", trigger: "blur" }],
                entrance_date: [{ required: true, message: "请选择入学时间", trigger: "change" }],
                grad_date: [{ required: true, message: "请选择毕业时间", trigger: "change" }],
                shape_title: [{ required: true, message: "请选择学习形式", trigger: "change" }],

                apply_remark: [{ required: true, message: "请输入申请原因", trigger: "blur" }],
                card_img_just_data: [{ required: true, message: "请选择身份证正面照(人像面)", trigger: "change" }],
                card_img_back_data: [{ required: true, message: "请选择身份证反面照(国徽面)", trigger: "change" }],
                archives_img_data: [{ required: true, message: "请选择学籍档案照片", trigger: "change" }],
                inch_img_data: [{ required: true, message: "请选择证件照", trigger: "change" }],

                apply_img_data: [{ required: true, message: "请选择申请书照片", trigger: "change" }],
            },
        };
    },
    created(){
        // this.$store.dispatch("common/getS3ClientAction"); // 获取腾讯云签名
        this.getSchoolList();  //获取函授站
        this.getProfessionList();  //获取专业
    },
    methods: {
        // 毕业证明书 申请记录
        goToPage(){
            this.$router.push({name: "graduationProveTable"});
        },
        // 弹窗 申请修改 提交
        submitInfo(){
            this.$refs["info"].validate(async (valid) => {
                if (valid) {
                    // 提交前 先上传图片
                    let card_img_just = this.uploadImg('card_img_just');
                    let card_img_back = this.uploadImg('card_img_back');
                    let archives_img = this.uploadImg('archives_img');
                    let inch_img = this.uploadImg('inch_img');
                    let apply_img = this.uploadImg('apply_img');
                    let funcs = [card_img_just, card_img_back, archives_img, inch_img, apply_img];
                    // let uploadImgFirstPhone = this.uploadImg('first_phone');
                    Promise.all(funcs).then(res => {
                        let {
                            student_title, 
                            identity,
                            student_code,
                            candidate_number,
                            school_id, 
                            school_title, 
                            class_title, 
                            level,
                            level_title,
                            profession_id, 
                            profession_title,
                            tel,
                            old_cert_code,
                            entrance_date,
                            grad_date,
                            shape_title,

                            apply_remark, 
                            card_img_just,
                            card_img_back,
                            archives_img,
                            inch_img,
                            
                            apply_img,
                        } = this.infoData;
                        let data = {
                            student_title, 
                            identity,
                            student_code,
                            candidate_number,
                            school_id, 
                            school_title, 
                            class_title, 
                            level,
                            level_title,
                            profession_id, 
                            profession_title,
                            tel,
                            old_cert_code,
                            entrance_date,
                            grad_date,
                            shape_title,

                            apply_remark, 
                            card_img_just,
                            card_img_back,
                            archives_img,
                            inch_img,
                            
                            apply_img,
                        };
                        studentPaGetPost(data).then(res => {
                            if(res.code == 200){
                                this.$message.success('提交成功');
                            }
                        });
                    });
                }
            });
        },
        // 点击 申请修改
        modifyClick(){
            this.isShowModifyInfo = true;
        },
        // 上传图片
        uploadImg(data){
            return new Promise((resolve, reject)=>{
                if (this.infoData[data + '_data'].length > 0) {
                    let type = this.infoData[data + '_data'][0].name.split('.').pop();
                    // 先上传头像再提交
                    putObject(this.infoData[data + '_data'][0], (url) => {
                        this.infoData[data] = url;
                        resolve();
                    }, null, 'student', type);
                }else{
                    resolve();
                }
            });
        },
        // 上传照片
        upLoadImg(data, type) {
            this.infoData[type] = '';
            this.infoData[type + '_data'] = data.fileList;
        },
        // 移除照片
        handleRemove(data, type) {
            this.infoData[type] = '';
            this.infoData[type + '_data'] = data.fileList;
        },
        // 选择专业
        professionChange(v){
            if(v !== ''){
                let professionId = v.split('-')[0];
                let professionTitle = v.split('-')[1];
                this.infoData.profession_id = professionId;
                this.infoData.profession_title = professionTitle;
            }else{
                this.infoData.profession_id = '';
                this.infoData.profession_title = '';
            }
        },
        // 选择函授站
        schoolChange(v){
            if(v !== ''){
                let schoolId = v.split('-')[0];
                let schoolTitle = v.split('-')[1];
                this.infoData.school_id = schoolId;
                this.infoData.school_title = schoolTitle;
            }else{
                this.infoData.school_id = '';
                this.infoData.school_title = '';
            }
            
        },
        // 学制层次筛选专业
        levelChange(v){
            this.infoData.profession_id = '';
            if(v !== ''){
                let levelId = v.split('-')[0];
                let levelTitle = v.split('-')[1];
                this.infoData.level = levelId;
                this.infoData.level_title = levelTitle;
            }else{
                this.infoData.level_id = '';
                this.infoData.level_title = '';
            }
            this.getProfessionList(this.infoData.level);
        },
        // 获取专业
        getProfessionList(v){
            let data = {
                level: v || '',
            };
            studentPaPro(data).then(res => {
                if(res.code == 200){
                    this.professionList = res.result;
                }
            });
        },
        // 获取函数站
        getSchoolList(){
            studentPaSchool().then(res => {
                if(res.code == 200){
                    this.schoolList = res.result;
                }
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.graduationProve{
    padding: 20px;
    height: 100vh;
    overflow-y: auto;
    .graduationProve-box{
        min-height: inherit;
        background-color: #fff;
        padding: 20px;
        position: relative;
        .top-btn{
            position: absolute;
            top: 20px;
            right: 20px;
            z-index: 1;
        }
        .cont{
            .top{
                text-align: right;
            }
        }
    }
}
</style>